/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeferredIncomeHistoryLoanDtoFromFund
 */
export interface DeferredIncomeHistoryLoanDtoFromFund {
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryLoanDtoFromFund
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryLoanDtoFromFund
   */
  name: string;
}

export function DeferredIncomeHistoryLoanDtoFromFundFromJSON(json: any): DeferredIncomeHistoryLoanDtoFromFund {
  return DeferredIncomeHistoryLoanDtoFromFundFromJSONTyped(json, false);
}

export function DeferredIncomeHistoryLoanDtoFromFundFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeferredIncomeHistoryLoanDtoFromFund {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function DeferredIncomeHistoryLoanDtoFromFundToJSON(value?: DeferredIncomeHistoryLoanDtoFromFund | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
